import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsOrganisationComponent extends Component {
  // Services
  @service data;

  // Defaults
  countries = [];

  // Hooks
  constructor() {
    super(...arguments);

    this.countries = this.data.getCategories({ 'filter[type]': 'COUNTRY' });
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='name' />
            <fieldset.field @property='shortName' />
            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field
              @property='assetId'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @property='linkId'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='controls' as |fieldset|>
            <fieldset.field @property='cmsLivedate' @type='date-time' />
            <fieldset.field @property='cmsKilldate' @type='date-time' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='contact' as |fieldset|>
            <fieldset.field @property='city' />
            <fieldset.field @property='street' />
            <fieldset.field @property='zipcode' />

            <fieldset.field
              @property='categoryId'
              @type='select-record'
              @options={{this.countries}}
            />

            <fieldset.field @property='fon' />
            <fieldset.field @property='fax' />
            <fieldset.field @property='email' />
          </form.fieldset>

          <form.fieldset @titleKey='taxes' as |fieldset|>
            <fieldset.field @property='taxNumber' />
            <fieldset.field @property='taxAuthorities' />
            <fieldset.field @property='ustIdent' />
            <fieldset.field @property='registerCourt' />
            <fieldset.field @property='hrb' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
